import React from "react";
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';

import logo from "../images/logo-full.svg";
import styles from "./header.module.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

export default () => (
    <Container
        fluid
        style={{
            backgroundColor: "#343a40",
            textAlign: "center",
            boxShadow: "0px 3px 8px black",
            paddingTop: "2rem",
            WebkitBoxShadow: "0px 3px 8px black",
            paddingBottom: "2rem",
            paddingLeft: "25%",
            paddingRight: "25%",
        }}>
        <Container fluid
            style={{
                maxWidth: 350
            }}>
            <Image src={logo}
                className={styles.shadow} />
        </Container>
    </Container>
);